import * as React from "react";
import { useState } from "react";
import { useLocalStorage } from "usehooks-ts";
import { faPen } from "@fortawesome/free-solid-svg-icons";
import { IconButton, Tooltip } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import BookmarkAddIcon from "@mui/icons-material/BookmarkAdd";
import { ColorIcon, DivGrid } from "./PersonalFilterStyles";
import PersonalFilterButton from "./PersonalFilterButton";
import { CustomFilter, PersonalFilterProps } from "./PersonalFilterInterfaces";

export default function PersonalFilter({ gridName, dataState, onApplyState }: PersonalFilterProps) {
  const [gridCustomButtons, setGridCustomButtons] = useLocalStorage<Array<CustomFilter>>(
    gridName,
    []
  );
  const [editMode, setEditMode] = useState<boolean>(false);

  const saveAsNewButton = () => {
    const newGridCustomButtons = [
      ...gridCustomButtons,
      { name: "New filter", dataState, uuid: Date.now().toString() },
    ];
    setGridCustomButtons(newGridCustomButtons);
  };

  const UpdateCustomFilter = (updatedFilter: CustomFilter) => {
    const customFilterIndex = gridCustomButtons.findIndex(
      (value) => value.uuid === updatedFilter.uuid
    );

    const newGridCustomButtons = [...gridCustomButtons];
    newGridCustomButtons[customFilterIndex] = updatedFilter;

    setGridCustomButtons(newGridCustomButtons);
  };

  const ToggleEditMode = () => {
    setEditMode(!editMode);
  };

  const deleteButton = (customFilter: CustomFilter) => {
    const newGridCustomButtons = gridCustomButtons.filter((f) => f.uuid !== customFilter.uuid);
    setGridCustomButtons(newGridCustomButtons);
  };

  const applyFilter = (customFilter: CustomFilter) => {
    onApplyState(customFilter.dataState);
  };

  return (
    <DivGrid>
      {gridCustomButtons.map((customFilter) => {
        return (
          <PersonalFilterButton
            editMode={editMode}
            onClick={() => applyFilter(customFilter)}
            onDeleteClick={() => deleteButton(customFilter)}
            customFilter={customFilter}
            onChange={UpdateCustomFilter}
          />
        );
      })}

      {editMode ? (
        <>
          <IconButton color="primary" onClick={saveAsNewButton}>
            <Tooltip title="Add current status as filter">
              <BookmarkAddIcon />
            </Tooltip>
          </IconButton>
          <IconButton onClick={ToggleEditMode}>
            <Tooltip title="Close edit mode">
              <CloseIcon />
            </Tooltip>
          </IconButton>
        </>
      ) : (
        <ColorIcon icon={faPen} onClick={ToggleEditMode} />
      )}
    </DivGrid>
  );
}
